// 	export default  [
// 	{ icon:'business', title: "办公业务",value: "办公业务",icon:'../../static/logo/tabarIndexLogo/business.png'},
// 	{ icon:'other', title: "其他",value: "其他",icon:'../../static/logo/tabarIndexLogo/other.png'},
// 	{ icon:'LeadershipView', title: "领导视图",value: "领导视图",icon:'../../static/logo/tabarIndexLogo/LeadershipView.png'}
// // ]

export default [
	{
		"costAmt": 0,
		"list": [
			{
				"eisaiName":'',				
				"invId": 0,
				"purcAmt": 0,
				"retnAmt": 0,
				"purcPric": 0,
				"purcType": 1,
				"retnCnt": 0,
				"saleAmt": 0,
				"purcCnt":'',
				"code":'',
				"salePric": 0
			}
		],
		"shedId": 9,
		"remarks": "",
		"retnTypeId": 11,
		"saleAmt": 0,
		"state": 0,
		"supplyCandidateId": ''
	}
]

